module.exports = __webpack_public_path__ + "img/de_bg_2.09c23ea2.jpeg";